import { render, staticRenderFns } from "./PreguntasFrecuentes.vue?vue&type=template&id=73b0ec58&scoped=true"
import script from "./PreguntasFrecuentes.vue?vue&type=script&lang=ts"
export * from "./PreguntasFrecuentes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b0ec58",
  null
  
)

export default component.exports